export default {
  data() {
    return {
      code: 'hello world',
    }
  },
  computed: {
    baseUrl() {
      return 'https://api.geomalaka.uz'
    },
    apiKey(){
      return 'id9irqz7k3ejxzj9b6cvt81cacm6uuog3hjk6dd1li9vukyw'
    }
  },
  methods:{
    logOuter(){
      localStorage.removeItem("access_token");
      this.$router.push("/login");
    }
  }

}
//id9irqz7k3ejxzj9b6cvt81cacm6uuog3hjk6dd1li9vukyw   20-08-2025 bexruz5113
//n6r6uvr5dhg4sa0kwgirqk0mqcvidal798kmgwxdxi7qlzvk
//8hje8rajuhrvcfr4rrgqzpl28w73zxejmroys0bt2olc84gq
//i1yfoapoykfb3a61dbisf1jy0xoyp1hjbc28ytjicnqd1u7p  29.10.2024 bexruzbahronov
//hw9aal8o7rnrauu70e5hgz9fh4wx1ymzk2u8iapo0ds55pdu
//vfigp4df201w1p7rz42b3ptujiteg8aygeg6dj4qfk9ml9np  18.09.2025 azizjon account
